import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
const phrases = ['La pieza que faltaba en tu salud', 'Elige entender, elige sanar', 'Toma el control frente al daño silencioso', 'Recupera la ventaja hoy', 'El mapa que tu médico no tuvo tiempo de darte', 'Glicación: el proceso que nadie te explicó', 'En español, con rigor, con respeto'];
const repeatedPhrases = [...phrases, ...phrases, ...phrases];
export function Marquee() {
  return <div className="bg-cream border-y border-border py-3.5 overflow-hidden flex items-center" data-id="element-220">
      <motion.div className="flex whitespace-nowrap items-center w-max" animate={{
      x: ['0%', '-50%']
    }} transition={{
      duration: 45,
      ease: 'linear',
      repeat: Infinity
    }} data-id="element-221">
        {repeatedPhrases.map((phrase, index) => <Fragment key={index} data-id="element-222">
            <span className="text-soft-gold mx-6 text-lg" data-id="element-223">✦</span>
            <span className="font-sans text-text-primary text-[13px] md:text-[14px] tracking-[0.15em] uppercase font-medium" data-id="element-224">
              {phrase}
            </span>
          </Fragment>)}
      </motion.div>
    </div>;
}